module.exports = "../study/imgs/maps/Tokyo/S8/Climate/Temperture/Tokyo_Temperture_HadGEM2_RCP26_End.png";